export default {
      id: "icon-internet-usage",
      viewBox: "0 0 58 58",
      url: __webpack_public_path__ + "icons.svg#icon-internet",
      toString: function () {
        return this.url;
      }
    }